// extracted by mini-css-extract-plugin
module.exports = {"mainHeading":"apiKey_mainHeading__2NqKh","fieldWrapper":"apiKey_fieldWrapper__37LRl","label":"apiKey_label__4HZ3n","buttonWrapper":"apiKey_buttonWrapper__2jGIJ"};